import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import useLangpackLoader from '@americanexpress/one-identity-components/lib/hooks/useLangpackLoader';
import { getHasPasskeysEnabled } from '../selectors';
import ErrorPage from './DefaultErrorPage';

const PasskeysWrapper = ({
  IdentityUiPasskeysRegistration,
  showIdentityUiPasskeysRegistration,
  loadStatus,
  route,
  ...rest
}) => {
  useLangpackLoader({ moduleName: 'one-identity-root' });

  if (loadStatus.all !== 'complete') {
    return null;
  }

  if (!showIdentityUiPasskeysRegistration) {
    return <ErrorPage route={{ code: '400' }} />;
  }

  return <IdentityUiPasskeysRegistration {...rest} isAED={route.path.includes('aed')} />;
};

PasskeysWrapper.propTypes = {
  IdentityUiPasskeysRegistration: PropTypes.func.isRequired,
  showIdentityUiPasskeysRegistration: PropTypes.func.isRequired,
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export const ComponentToTest = PasskeysWrapper;

const loadDataAsProps = ({ store: { dispatch, getState } }) => ({
  IdentityUiPasskeysRegistration: () => dispatch(queryModuleWithData('identity-ui-passkeys-registration')),
  showIdentityUiPasskeysRegistration: () => ({ status: 'complete', data: getHasPasskeysEnabled(getState()) }),
});

const hocChain = compose(
  oneAppModuleWrapper(PasskeysWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(PasskeysWrapper);
